export const REPORT_ERROR = 'REPORT_ERROR';
export const REPORT_REQUEST = 'REPORT_REQUEST';
export const REPORT_SUCCESS = 'REPORT_SUCCESS';


